import { render, staticRenderFns } from "./BalancoForm.vue?vue&type=template&id=ecf86ab0&scoped=true"
import script from "./BalancoForm.vue?vue&type=script&lang=js"
export * from "./BalancoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf86ab0",
  null
  
)

export default component.exports